import { UniversityDTO, UniversityIdpDTO } from "@onetutor/shared/dto";
import { buildQueryString } from "../utils/api.util";
import { onetutorApi } from "./onetutorApi";

const universityApi = onetutorApi.injectEndpoints({
  endpoints: (builder) => ({
    getUniversities: builder.query<UniversityDTO[], void>({
      query: () => "university",
      providesTags: ["university"],
    }),
    getUniversityIdp: builder.query<UniversityIdpDTO, void>({
      query: () =>
        buildQueryString("university/idp", {
          origin: window.location.origin,
        }),
      providesTags: ["university"],
    }),
  }),
});

export const { useGetUniversitiesQuery, useGetUniversityIdpQuery } =
  universityApi;
